import { IVendasItens } from '../../../types/tables/IVendasItens';
import { supabase } from '../../../../supabaseConfig';

/**
 * Serviço para gerenciamento de itens de vendas
 * Gerencia os itens detalhados de cada venda
 */
export class VendasItensService {
     protected client = this.getClient();

     private getClient() {
          return supabase;
     }

     /**
      * Busca itens por venda
      */
     async getByVenda(vendaId: number) {
          return await this.client
               .from('vendas_itens')
               .select(`
                    *,
                    produtos (descricao, descricao_reduzida, valor)
               `)
               .eq('fk_id_venda', vendaId)
               .order('created_at');
     }

     /**
      * Busca itens por produto
      */
     async getByProduto(produtoId: number) {
          return await this.client
               .from('vendas_itens')
               .select(`
                    *,
                    vendas!fk_id_venda (numero_venda, data_venda, valor_total)
               `)
               .eq('fk_id_produto', produtoId)
               .order('created_at', { ascending: false });
     }

     /**
      * Calcula total de vendas por produto
      */
     async getTotalVendasProduto(produtoId: number) {
          const { data } = await this.client
               .from('vendas_itens')
               .select('quantidade.sum(), valor_total.sum()')
               .eq('fk_id_produto', produtoId);
          
          return data?.[0] || { sum: 0 };
     }

     /**
      * Calcula valor total dos itens de uma venda
      */
     async getValorTotalVenda(vendaId: number) {
          const { data } = await this.client
               .from('vendas_itens')
               .select('valor_total.sum()')
               .eq('fk_id_venda', vendaId);
          
          return data?.[0]?.sum || 0;
     }

     /**
      * Cria um novo item de venda
      */
     async create(item: Omit<IVendasItens, 'id' | 'created_at'>) {
          return await this.client
               .from('vendas_itens')
               .insert(item)
               .select()
               .single();
     }

     /**
      * Atualiza um item de venda
      */
     async update(id: number, updates: Partial<IVendasItens>) {
          return await this.client
               .from('vendas_itens')
               .update(updates)
               .eq('id', id)
               .select()
               .single();
     }

     /**
      * Remove um item de venda
      */
     async delete(id: number) {
          return await this.client
               .from('vendas_itens')
               .delete()
               .eq('id', id);
     }
}
